import request from '@/utils/request'

export default {
  methods: {
    $img (name) {
      return require(`@/assets/images/${name}`)
    },
    $api ( method, url, params = {} ) {
      let paramsData = params
      if ( method == 'GET' || method == 'get' ) {
        paramsData = '?'
        for (const key in params) {
          paramsData += `${key}=${params[key]}&`
        }
        paramsData = paramsData.substr(0, paramsData.length - 1)
      }
      return new Promise((resolve,reject) => {
        request({
          method: method,
          url: method == 'GET' || method == 'get' ? `${url}${paramsData}` : url,
          data: paramsData
        }).then(res => {
          resolve(res.data)
        }).catch(( error ) => {
          console.log('error:', error)
          reject('接口请求出错，请稍后重试…')
        })
      })
    }
  }
}